import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, filter, of, switchMap } from 'rxjs';
import { getSortedLanguageList, Language } from '../../common/constants/language';
import { RequestHeader } from '../../store/constants/headers';
import { ApplicationTypeToken, EnvironmentName } from './environment.constant';
import { Environment } from './environment.model';
import { FaroService } from './faro.service';
import { FaroRouterTrackerService } from './faro-router-tracker.service';

export let API_URL = '';
export let ROOT_ENV = '';
export let ENV_NAME: EnvironmentName;
export let OPEN_INFO_API_URL = '';
export let FCM_API_URL = '';
export let WS_API_URL = '';
export let SKID_URL = '';
export let SKID_CHINA_URL = '';

export let GOOGLE_MAPS_API_KEY = '';
export let INSPECTION_BASE_URL = '';
export let FARO_COLLECTOR_URL = '';
export let FARO_API_KEY = '';
export let AG_GRID_LICENSE_KEY = '';

export let APP_LANGUAGES: Language[] = [];

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private languages = [];
  private apiUrl$: BehaviorSubject<string> = new BehaviorSubject(null);
  constructor(
    private http: HttpClient,
    private faroService: FaroService,
    private faroRouterTrackerService: FaroRouterTrackerService,
  ) {}

  public getConfig(applicationType: ApplicationTypeToken): Promise<boolean> {
    return new Promise((resolve: (value: boolean | PromiseLike<boolean>) => void) => {
      this.http
        .get('./assets/app-config.json', {
          headers: new HttpHeaders({
            [RequestHeader.SkipInterceptor]: '',
          }),
        })
        .subscribe((response: Environment) => {
          API_URL = response.api.apiUrl;
          ROOT_ENV = response.rootEnv;
          ENV_NAME = response.envName;
          OPEN_INFO_API_URL = response.api.openInfoApiUrl;
          FCM_API_URL = response.api.fcmApiUrl;
          WS_API_URL = response.api.wsApiUrl;
          SKID_URL = response.api.skidUrl;
          SKID_CHINA_URL = response.api.skidChinaUrl;
          GOOGLE_MAPS_API_KEY = response.googleMapsApiKey;
          INSPECTION_BASE_URL = response.inspectionBaseUrl;
          FARO_COLLECTOR_URL = response.faroCollectorUrl;
          FARO_API_KEY = response.faroApiKey;
          AG_GRID_LICENSE_KEY = response.agGridLicenseKey;

          this.faroService.initialize(FARO_COLLECTOR_URL, FARO_API_KEY, ENV_NAME);
          this.faroRouterTrackerService.initialize();

          // TODO: create separate configuration for different apps
          this.apiUrl$.next(applicationType === ApplicationTypeToken.IntrackApp ? API_URL : OPEN_INFO_API_URL);
          resolve(true);
        });
    });
  }

  public loadLanguages(): Promise<boolean> {
    return new Promise((resolve: (value: boolean | PromiseLike<boolean>) => void) => {
      this.apiUrl$
        .pipe(
          filter(Boolean),
          switchMap((url: string) => {
            return this.http
              .get<Language[]>(`${url}/languages`, {
                headers: new HttpHeaders({
                  [RequestHeader.SkipInterceptor]: '',
                }),
              })
              .pipe(catchError((_err: HttpErrorResponse) => of([])));
          }),
        )
        .subscribe((languages: Language[]) => {
          APP_LANGUAGES = languages;
          this.languages = getSortedLanguageList();
          resolve(true);
        });
    });
  }

  public getLanguages(): string[] {
    return this.languages;
  }
}
